import { TranslateString } from './translation.types';
import { ModuleOverrides, TextOverrides } from './content-overrides.types';

/**
 *

 DO NOT reorder these

 If you need to add another module type, add them to the bottom
 we have stuff that depends on this enumerator being in this order

 */
export enum PageModuleType {
  main_event_banner,
  speakers,
  agenda,
  about,
  products,
  videos,
  sponsors,
  callout,
  documents,
  feed,
  embed_widget,
  slideshows,
  questions,
  quizzes,
  survey,
  broadcast,
  description,
  similar_sessions,
  blank,
  people,
  breakout_room,
  accordion,
  comment_box_prompt,
  courses,
}

export interface PageModule {
  id?: number;
  type: PageModuleType;
  is_on: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content_modules?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modules?: any[];
  is_custom?: boolean;
  styling_overrides?: {
    background?: {
      color: string; //keyof ColorOptions with "-background" appended
      //eg.("backgroundColor-background", "accentColor-background", "customColor0-background")
      image: {
        is_on: boolean;
        src: string;
      };
    };
    content?: {
      start_time?: TextOverrides;
      title?: TextOverrides;
      description?: TextOverrides;
      custom_heading?: TextOverrides;
      modules?: ModuleOverrides;
      registration_page_stream_date?: TextOverrides;
      registration_page_speakers_lineup?: TextOverrides;
    };
  };
  ordinal?: number;
  is_edited: boolean | null;
  module_display_info?: ModuleDisplayInfo | null;
  // New parameters must be optional or nullable
}

export interface ModuleDisplayInfo {
  session_display_options?: SessionDisplayOptions;
  content_track_order?: string[];
  session_display_all?: SessionDisplayAll;
}

export interface SessionDisplayOptions {
  [identifer: string]: number[];
}

export interface SessionDisplayAll {
  liveSessions: boolean;
  onDemandSessions: boolean;
  [identifer: string]: boolean;
}

export interface Module {
  module_id?: number;
  channel: number;
  status: ModuleStatus;
  archived: boolean;
  base_language: string;
  created_by: number;
  created_at: Date;
  modified_by: number;
  modified_at: string;
  // New parameters must be optional or nullable
}

export enum ModuleStatus {
  deleted,
  active,
}

export interface PageModuleGroupModules {
  icon?: string;
  uuid: string;
  name: ModuleGroups | TranslateString;
  is_on: boolean;
  modules: number[]; // array of module ids representing the display order
  type?: string;
  // New parameters must be optional or nullable
}

export enum ModuleGroups {
  Overview = 'Overview',
  QuizzesAndPolls = 'Quizzes and Polls',
  Documents = 'Documents',
  QuestionsAndPosts = 'Questions and Posts',
  Quizzes = 'Quizzes',
  Surveys = 'Surveys',
  BreakoutRooms = 'Breakout Rooms',
  Engage = 'Engage',
  Details = 'Details',
  Extras = 'Extras',
  Credits = 'Credits',
}

export const ModuleGroupingTypes = {
  Breakouts: 'breakout',
  Overview: 'overview',
  Engage: 'engage',
  Extras: 'extras',
  Education: 'education',
  Details: 'details',
  Polls: 'polls',
  Documents: 'documents',
  Questions: 'questions',
  Surveys: 'surveys',
  custom: 'custom',
  CommentsBox: 'comment box',
};

export interface CreateQuestionPrompt {
  title: TranslateString;
  settings: {
    likes: boolean;
    replies: boolean;
    anonymous_replies: boolean;
    private_responses?: boolean;
  };
}

export interface IQuestionPromptTranslations {
  [key: string]: TranslateString;
}

export interface QuestionPrompt extends Module {
  question_prompt: number;
  title: TranslateString;
  settings: {
    likes: boolean;
    replies: boolean;
    anonymous_replies: boolean;
    translations?: IQuestionPromptTranslations;
  };
}

interface ModuleMapType {
  [key: number]: string;
}

export const ModuleMap: ModuleMapType = {
  [PageModuleType.main_event_banner]: 'Main Banner',
  [PageModuleType.speakers]: 'Speakers',
  [PageModuleType.agenda]: 'Sessions & Content',
  [PageModuleType.about]: 'About',
  [PageModuleType.videos]: 'Videos',
  [PageModuleType.callout]: 'Callout',
  [PageModuleType.sponsors]: 'Sponsors',
  [PageModuleType.broadcast]: 'Broadcast',
  [PageModuleType.questions]: 'Questions',
  [PageModuleType.quizzes]: 'Quizzes',
  [PageModuleType.survey]: 'Surveys',
  [PageModuleType.products]: 'Products',
  [PageModuleType.slideshows]: 'Slideshows',
  [PageModuleType.documents]: 'Documents',
  [PageModuleType.similar_sessions]: 'Suggested',
  [PageModuleType.feed]: 'Feed',
  [PageModuleType.embed_widget]: 'Embed Widget',
  [PageModuleType.description]: 'Description',
  [PageModuleType.blank]: 'Blank Section',
  [PageModuleType.people]: 'People',
  [PageModuleType.accordion]: 'Accordion',
  [PageModuleType.comment_box_prompt]: 'Comment Box',
  [PageModuleType.courses]: 'Courses',
};
export interface Product extends Module {
  product?: number;
  tab_title: TranslateString;
  product_title: TranslateString;
  images: string[];
  categories: string[];
  description: TranslateString;
  price: TranslateString;
  buy_now_link: string;
  sale_price: TranslateString;
  button_text: TranslateString;
  attributes: ProductAttribute[] | null;
  use_attributes: boolean;
  cta_new_tab?: boolean;
  parent_id: number | null;
  event_id: number | null;
  should_create_channel_product?: boolean;
  settings?: {
    bypass_modal?: boolean;
    categories_translations?: {
      [key: string]: TranslateString;
    };
    include_utm_params?: boolean;
  };
}

export interface ProductAttribute {
  type: string;
  value: string;
  // New parameters must be optional or nullable
}

export type FileType = `${string}/${string}`;

export enum ThumbnailStatus {
  never,
  generating,
  done,
}

export interface IDocumentMiscTranslations {
  [key: string]: TranslateString;
}

export interface Document extends Module {
  document: number;
  original_name: string;
  location: string;
  thumbnail: string | null;
  thumbnail_status: ThumbnailStatus;
  filesize: number;
  display_name: TranslateString;
  generated_thumbnail: string | null;
  misc_translations?: IDocumentMiscTranslations;
  // New parameters must be optional or nullable
}

export interface CreateDocument {
  original_name: string;
  location: string;
  thumbnail: string | null;
  thumbnail_status: ThumbnailStatus;
  filesize: number;
  display_name: TranslateString;
  generated_thumbnail: string | null;
  // New parameters must be optional or nullable
}
